export const qlTypes = {
    graph_ql_node: {
        name: 'Чарт (QL)',
        tabs: [
            {
                name: 'QL',
                id: 'query',
                language: 'sql',
            },
        ],
    },
};
